import script from "./searchbox.vue?vue&type=script&setup=true&lang=js"
export * from "./searchbox.vue?vue&type=script&setup=true&lang=js"

import "./searchbox.vue?vue&type=style&index=0&id=9ca452fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ca452fc"]])

export default __exports__